// updateCart
// $(document).ready(function() {
//    $('body').on('keyup','.measurement-per-unit', function() {
//      var btn=$('.update_btn');
//      $(btn).prop('disabled', true);
//         if($(this).val != ''){
//            $(btn).prop('disabled', false);
//         }
//     });
// })
// $(document).ready(function() {
//    $('body').on('keyup','.measurement-quantity', function() {
//      var btn=$('.update_btn');
//      $(btn).prop('disabled', true);
//         if($(this).val != ''){
//            $(btn).prop('disabled', false);
//         }
//     });
// })
// $(document).ready(function() {
//    $('body').on('click','.plus', function() {
//      var btn=$('.update_btn');
//      $(btn).prop('disabled', true);
//         if($(this).val != ''){
//            $(btn).prop('disabled', false);
//         }
//     });
// })
// $('body').on('keyup', '.measurement-per-unit', function(e) {
//   e.preventDefault();
//   const input = $(this);
//   var key=$(input).attr('key');
//   const newQuantity = Number(input.val());
//   const areaPerBox = 1.44; 
//   const newMeasurement = newQuantity * areaPerBox;
//   var d=$('.measurement-quantity');
//    $(d).each(function(i,ele) {
//       var item = $(this);
//       var key2 = item.attr('key2');
//      if(key==key2){     
//     $(ele).val(newMeasurement.toFixed(2));
//      }
//     });  
// }) 

// $('body').on('keyup', '.measurement-quantity', function(e) {
//   e.preventDefault();
//   const input = $(this);
//   var key2=$(input).attr('key2');
//   const newQuantity = Number(input.val());
//   const areaPerBox = 1.44; 
//   const newMeasurement =parseInt(newQuantity / areaPerBox + 1);
//   var d=$('.measurement-per-unit');
//    $(d).each(function(i,ele) {
//       var item = $(this);
//       var key = item.attr('key');
//      if(key==key2){     
//     $(ele).val(newMeasurement);
//      }
//     });  
// })


// $('body').on('click', '.plus', function() {
//     var $input = $(this).parent().find('input');
//     $input.val(parseInt($input.val()) + 1).trigger('keyup');
//     return false;
// });
// $('body').on('click', '.minus', function() {
//     var $input = $(this).parent().find('input');
//     $input.val(parseInt($input.val()) - 1).trigger('keyup');
//     return false;
// });



// Click event for manual "Update Cart" button
// $('body').on('click', '.actions button', function(e) {
//     e.preventDefault();
//     updateCartFromForm();
// });





// $('body').on('click', '.actions button', function(e) {
//     e.preventDefault();
//     var form = $(this).closest('form');    
//     let updates = {};
//     $(form).find('.woocommerce-cart-form__cart-item').each(function() {
//         const item = $(this);
//         const key = item.attr("data-line-item-key");
//         const newQuantity = Number(item.find('.measurement-per-unit').val());
//         if (newQuantity !== '' && newQuantity >= 0) {
//             updates[key] = newQuantity;
//         }
//     });

//     if (Object.keys(updates).length > 0) {
//         updateCart(updates);
//     } else {
//         console.log("No valid updates");
//     }
// });
//  $(document).on("click", "#zip_search", function() {
//     console.log("111111111111111")
//    var postal_code =  $('#postal_code').val();
//     console.log("postal_code",postal_code);
//    // var input_postcode = $('#input_postcode').text(postal_code)
//   $('#input_postcode').val(postal_code);
//    $("#search_postcode").trigger("click");
//        // $(".error-cls #postal-code-error").hide();
//      setTimeout(function() {
//         if ($(".error-cls #postal-code-error").is(":visible")) {
//             // $('.search-content-wrap').remove();
//            $(".appended-shipping").remove();
//         } else {
//             $(".appended-shipping").remove();
//             var shippingElement = $("#shipping_rates").clone();
//             if (shippingElement.length > 0) {
//                 shippingElement.css("display", "block").addClass("appended-shipping");
//                 $(".input-content-block").after(shippingElement);
//             }
//         }
//     }, 1000);
   
// });

// if($('input#csDatepicker').val()== null || $('input#csDatepicker').val()== ''){
//   $(".appended-shipping").hide();
// }else{
//  $(".appended-shipping").show();
// }

// $(document).on("click", "#zip_search", function() {
//     var postal_code = $('#postal_code').val();

//     $('#input_postcode').val(postal_code);
//     $("#search_postcode").trigger("click");

//     setTimeout(function() {
//         $(".appended-shipping").remove();
//         $("#hidden-shipping-message").remove();
      
//         if ($("#cs_shipping_rate .form .ShippingEstimator__Error ").hasClass("activeMsg")) {
//             var errorMessage = $("#cs_shipping_rate .form").attr('data-ship_err');
//             if (errorMessage.length > 0) {
//                 $(".input-content-block").after('<div id="hidden-shipping-message" class="shipping-mass" style="display: block;color: red;"></div>');
//                 $("#hidden-shipping-message").append(errorMessage);
//             }
//         } else {
//             // Store success message but don't show it yet
//             var shippingElement = $("#shipping_rates").clone();   
          
//             if (shippingElement.length > 0) {
//                 shippingElement.css("display", "block").addClass("appended-shipping");
//                 $(".input-content-block").after('<div id="hidden-shipping-message" style="display: none;"></div>');
//                 $("#hidden-shipping-message").append(shippingElement);
//             }
//         }
//     }, 2000);
// });

// $(document).on("input blur", "#csDatepicker", function() {
//     var selectedDate = $(this).val();
//   console.log(54432354);
//     if (selectedDate.trim() !== "") {
//         $("#hidden-shipping-message").css("display", "block");
//     } 
// });
// function sbzDateUpdate(dateText) {
//   if (dateText && $('.cs-tab_last[rel="cs-tab2"]').hasClass('active')) {
function sbzZipcodeUpdate(csPostalCode) {
  console.log("111111111111")
  if (csPostalCode && $('.cs-tab_last[rel="cs-tab2"]').hasClass('active')) {
    $('.cs-loader').show();
    $(".appended-shipping").remove();
    $("#hidden-shipping-message").remove();
    var postal_code = $('#postal_code').val();
    $('#input_postcode').val(postal_code);
    $("#search_postcode").trigger("click");
    setTimeout(function() {
      // if ($("#cs_shipping_rate .form .ShippingEstimator__Error ").hasClass("activeMsg")) {
      //   var errorMessage = $("#cs_shipping_rate .form").attr('data-ship_err');
      //   if (errorMessage.length > 0) {
      //     $(".input-content-block").after('<div id="hidden-shipping-message" class="shipping-mass" style="display: block;color: red;"></div>');
      //     $("#hidden-shipping-message").append(errorMessage);
      //     $('.cs-loader').hide();
      //     $("#hidden-shipping-message").show();
      //   }
      // } else {
        var shippingElement = $("#shipping_rates").clone();   
        if (shippingElement.length > 0) {
          shippingElement.css("display", "block").addClass("appended-shipping");
          $(".input-content-block").after('<div id="hidden-shipping-message" style="display: none;"></div>');
          $("#hidden-shipping-message").append(shippingElement);
          $('.cs-loader').hide();
          $("#hidden-shipping-message").show();
        }
      // }
    }, 2000);
  }
}
// $(document).off('click', '.product-remove .remove')
$('body').on("click", ".cs-tab_last", function(e) {
    e.preventDefault();
    setTimeout(() => {
        let activeTab = $('.cs-crawler-tabs li.active'); 
        if (activeTab.attr("rel") === "cs-tab3") {
            // $('#input_postcode').val('');
            // $("#search_postcode").trigger("click");
           $("#hidden-shipping-message").hide();
           $('#input_postcode').val('').promise().done(() => {
                $("#search_postcode").trigger("click");
            });
        }
        else if (activeTab.attr("rel") === "cs-tab1") {      
          // $('#input_postcode').val('');
          // $("#search_postcode").trigger("click");
          $('#cs-tab1 .tab-inner-content p').text("Please checkout as normal and we will be in contact regarding the overseas shipping charge.");
         $("#hidden-shipping-message").hide();
         $('#input_postcode').val('').promise().done(() => {
              $("#search_postcode").trigger("click");
          });
      }
    }, 100);
});
function csOuterfunction(){
    $('[rel="cs-tab2"]').trigger("click");
    $('#csShippingAppCode .CS-custom-tab-section').append('<span class="cs-loader"></span>')
    // Find the specific 'Overseas Shipping' tab
    $(".cs-tab_last[rel='cs-tab1']").find("svg").last().replaceWith(`
        <svg fill="#000000" version="1.1" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 471.461 471.461">
            <g>
                <path d="M235.735,471.456c129.984,0,235.726-105.752,235.726-235.726c0-129.973-105.752-235.725-235.726-235.725
                C105.761,0.005,0,105.747,0,235.73C0,365.714,105.751,471.456,235.735,471.456z M421.152,193.942
                c-19.662-11.465-14.746,1.635-14.746,1.635s0,0,13.109,11.465c13.111,11.466,22.941,16.39,18.025,32.445
                c-4.914,16.057-13.109,1.961-29.49,15.072c-16.391,13.109,19.66,16.389,21.295,36.049c1.637,19.662-19.66,9.832-29.49,29.492
                s-1.635,40.965-6.551,58.99c-4.914,18.025-45.881,42.602-60.76,50.797s-4.781-18.025,0-36.051s-11.34-37.686-11.34-70.457
                s-9.83-22.939-39.322-22.939c-29.49,0-42.6-16.391-45.88-47.518c-3.28-31.135,24.576-62.261,37.685-72.091
                c13.111-9.831,31.137-19.661,49.152-9.831c18.025,9.831,24.576,19.661,44.236,19.661s19.66-6.55,31.135-14.746
                c11.465-8.195-16.391-18.025-32.77-16.313c-16.381,1.712-13.111-9.897-34.406-18.092c-21.297-8.195-29.492,8.195-36.051,11.465
                c-6.551,3.28-29.49,13.11-31.787,0c-2.285-13.11,12.117-14.745,26.871-14.745c14.746,0,1.635-11.465-3.279-19.661
                c-4.916-8.195-14.746-8.195-21.85-14.592c-7.096-6.397,8.74-18.178,25.119-14.267c16.381,3.911,9.83,15.75,27.855,14.114
                s0-18.025,0-33.899c0-15.874,19.662-15.262,32.771-21.592c13.109-6.331,29.49,27.635,40.965,41.377
                c3.797,4.552,9.219,2.534,14.766-2.113c28.984,33.354,48.367,75.228,53.836,121.338
                C436.824,217.695,438.346,203.973,421.152,193.942z"/>
            </g>
        </svg>
    `);
}




function refreshCart() {
  $.ajax({
    url: '/cart?t='+Math.random(),
    method: 'GET',
    dataType: 'html',
    success: function(data) {  
      var formContent=$(data).find('[clear]');
      $('[clear]').html(formContent.html());
      
    },
    error: function(error) {
      console.log("Refresh Cart Error:", error);
     
    }
  });
}
$('body').on('keyup', '.measurement-per-unit', function(e) {
  console.log("hii");
  // e.preventDefault();
  const input = $(this);
   measurementPerUnit(input);
  
});

function measurementPerUnit(input) {
  // const input = $(input);
  var key = $(input).attr('key');
  const newQuantity = Number(input.val());
  const areaPerBox = $(input).attr("data-m2"); 
  const newMeasurement = newQuantity * areaPerBox;
  $('.measurement-quantity').each(function() {
    var item = $(this);
    var key2 = item.attr('key2');
    if (key == key2) {     
      $(item).val(newMeasurement.toFixed(2));
    }
  });  
  $(input).parents(".woocommerce-cart-form__cart-item").addClass("loader_active");    
  updateCartFromForm();
}

$('body').on('keyup', '.measurement-quantity', function(e) {
  // e.preventDefault();
   const input = $(this);
  
 measurementQuantity(input);
      
});

function measurementQuantity(input) {
   // const input = $(input);
  var key2 = $(input).attr('key2');
  const newQuantity = Number(input.val());
  const areaPerBox = $(input).attr("data-m2"); 
  const newMeasurement = Math.ceil(newQuantity / areaPerBox); 
  
  $('.measurement-per-unit').each(function() {
    var item = $(this);
    var key = item.attr('key');
    if (key == key2) {         
      $(item).val(newMeasurement);
    }
  });  
  $(input).parents(".woocommerce-cart-form__cart-item").addClass("loader_active");  
   updateCartFromForm();
}

 $('body').on('click', '.plus, .minus', function() { 
    var $input = $(this).parent().find('.measurement-per-unit');
    var newValue = parseInt($input.val()) + ($(this).hasClass('plus') ? 1 : -1);
   $input.val(newValue)
     var input= $(this).parent().find('.measurement-per-unit');
     var input2= $(this).parent().find('.measurement-quantity');
   
     measurementPerUnit(input)
   measurementQuantity(input2)
    // if (newValue < 1){
    //    var $item = $(this).closest(".update-cart");
    //    var key = $item.attr("data-line-item-key");
    //    removeItem(key);
    // }
      // $input.val(newValue).trigger('keyup');
  
    // updateCartFromForm();
    // return false;
});

function updateCartFromForm() {
    let updates = {};
    $('.woocommerce-cart-form__cart-item').each(function() {
      // $(this).addClass("loader_active");
        const item = $(this);
        const key = item.attr("data-line-item-key");
        const newQuantity = Number(item.find('.measurement-per-unit').val());
        if (!isNaN(newQuantity) && newQuantity >= 0) {
            updates[key] = newQuantity;
        }
    });

    if (Object.keys(updates).length > 0) {
        updateCart(updates);
    } else {
        console.log("No valid updates");
    }
}


function updateCart(updates) {
   $.ajax({
      url: '/cart/update.js',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ updates: updates }),
      dataType: 'json',
      success: function(data) {  
        refreshCart();
        countCart();
      },
     complete: function() {
        $(".woocommerce-cart-form__cart-item").removeClass("loader_active");
      },
      error: function(response) {
        console.log("Update Cart Error:", response);    
      }
    });
}


// remove cart

$(document).off('click', '.product-remove .remove').on('click', '.product-remove .remove', function(e) {
  e.preventDefault();
  var $item = $(this).closest(".update-cart");
  var key = $item.attr("data-line-item-key");
  $(this).parents(".woocommerce-cart-form__cart-item").addClass("loader_active");
 removeItem(key);
});
function removeItem(key) {
  $.ajax({
    url: '/cart/update.js',
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ updates: { [key]: 0 } }),
    dataType: 'json',
    success: function(data) {
       $('.remove-cart').each(function() {
          var $item = $(this);
          var key = $item.attr('data-line-item-key');
          var exists = data.items.some(function(item) {
              return item.key === key;
          });
          if (!exists) {
            $item.remove();
          }
         countCart();
        refreshCart();
      });  
    },
    complete: function() {
        $(".woocommerce-cart-form__cart-item").removeClass("loader_active");
      },
    error: function(error) {
      console.log("Remove Cart Error:", error);
    }
  });

}